import { render, staticRenderFns } from "./real-new-tree.vue?vue&type=template&id=c564b3a6"
import script from "./real-new-tree.vue?vue&type=script&lang=js"
export * from "./real-new-tree.vue?vue&type=script&lang=js"
import style0 from "./real-new-tree.vue?vue&type=style&index=0&id=c564b3a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports